import gallery1 from "@/assets/gallery-1.jpg";
import gallery2 from "@/assets/gallery-2.jpg";
import gallery3 from "@/assets/gallery-3.jpg";
import gallery4 from "@/assets/gallery-4.jpg";
import gallery5 from "@/assets/gallery-5.jpg";
import gallery6 from "@/assets/gallery-6.jpg";
import gallery7 from "@/assets/gallery-7.jpg";
import gallery8 from "@/assets/gallery-8.jpg";
import gallery9 from "@/assets/gallery-9.jpg";
import video1 from "@/assets/video-1.mp4";
import video2 from "@/assets/video-2.mp4";
import video3 from "@/assets/video-3.mp4";
import video4 from "@/assets/video-4.mp4";
import video5 from "@/assets/video-5.mp4";
import video6 from "@/assets/video-6.mp4";

export type MediaItem = {
  type: "image" | "video";
  src: string;
  alt: string;
  poster?: string;
  mirror?: boolean;
};

/**
 * Jedno, spójne źródło alt textów dla statycznych mediów galerii i produktów.
 * Alt texty są zoptymalizowane pod SEO (słowa kluczowe: naklejki 3D, doming,
 * żywica poliuretanowa) i współdzielone przez GallerySection oraz stronę Produkty.
 */
export const staticMedia: MediaItem[] = [
  { type: "video", src: video1, alt: "Naklejki wypukłe 3D zalewane żywicą – film produkcyjny doming", poster: gallery1, mirror: true },
  { type: "video", src: video2, alt: "Maszynowa produkcja naklejek domingowych – proces zalewania żywicą poliuretanową", poster: gallery2, mirror: true },
  { type: "video", src: video3, alt: "Naklejki 3D z logo firmy – efekt końcowy naklejek żywicznych premium", poster: gallery3, mirror: true },
  { type: "video", src: video4, alt: "Realizacja zamówienia naklejek 3D doming – naklejki reklamowe", poster: gallery4, mirror: true },
  { type: "video", src: video5, alt: "Naklejki samoprzylepne 3D – prezentacja produktu naklejek wypukłych", poster: gallery5, mirror: false },
  { type: "video", src: video6, alt: "Detale naklejek epoksydowych 3D – jakość i trwałość ponad 15 lat", poster: gallery6, mirror: false },
  { type: "image", src: gallery1, alt: "Naklejki wypukłe 3D na szczotkowanej stali – etykiety firmowe zalewane żywicą poliuretanową" },
  { type: "image", src: gallery2, alt: "Naklejki domingowe z logo firmy – seria produkcyjna naklejek 3D premium" },
  { type: "image", src: gallery3, alt: "Owalne naklejki 3D zalewane żywicą z logo – naklejki w dowolnym kształcie" },
  { type: "image", src: gallery4, alt: "Logo firmy w formie naklejki żywicznej – kolorowe etykiety 3D wypukłe" },
  { type: "image", src: gallery5, alt: "Holograficzne naklejki 3D z efektem tęczowym – naklejki premium ze złoceniem" },
  { type: "image", src: gallery6, alt: "Eleganckie naklejki 3D ze złoconym wzorem – naklejki reklamowe dla firm" },
  { type: "image", src: gallery7, alt: "Naklejki 3D na samochody – emblematy samochodowe zalewane żywicą odporne na UV" },
  { type: "image", src: gallery8, alt: "Naklejki żywiczne z logo marki – maszynowa produkcja naklejek domingowych" },
  { type: "image", src: gallery9, alt: "Naklejki 3D doming z kolorowym logo – naklejki na produkty personalizowane" },
];

const ALT_BASE = "Naklejki 3D doming zalewane żywicą";

/**
 * Generuje spójny, zoptymalizowany pod SEO alt text dla mediów z CMS.
 * Jeśli administrator nie wpisał opisu, tworzony jest sensowny alt na bazie
 * słów kluczowych marki oraz typu medium i jego pozycji.
 */
export function buildAltText(item: { alt?: string | null; type: string }, index: number): string {
  const provided = item.alt?.trim();
  if (provided) return provided;
  const kind = item.type === "video" ? "film produkcyjny" : "zdjęcie realizacji";
  return `${ALT_BASE} – ${kind} naklejek wypukłych nr ${index + 1}`;
}

/**
 * Tworzy zoptymalizowaną pod SEO nazwę pliku (slug) na podstawie opisu/alt.
 * Polskie znaki są transliterowane, spacje zamieniane na myślniki.
 */
export function buildSeoFileName(base: string, ext: string, fallback = "naklejka-3d-doming"): string {
  const map: Record<string, string> = {
    ą: "a", ć: "c", ę: "e", ł: "l", ń: "n", ó: "o", ś: "s", ź: "z", ż: "z",
  };
  const slug = (base || "")
    .toLowerCase()
    .replace(/[ąćęłńóśźż]/g, (c) => map[c] || c)
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60)
    .replace(/-+$/g, "");
  const safe = slug || fallback;
  return `${safe}-${Date.now()}.${ext}`;
}
